const HUB_MESSAGE_SIZE_LIMIT_IN_BYTES = 1024 * 1024 * 16;
const HUB_ENVELOPE_HEADROOM_IN_BYTES = 64 * 1024;

export const ALLOWED_FILE_SIZE_IN_BYTES = Math.floor(
  ((HUB_MESSAGE_SIZE_LIMIT_IN_BYTES - HUB_ENVELOPE_HEADROOM_IN_BYTES) * 3) / 4,
);

export function base64ByteLength(base64: string): number {
  const padding = base64.endsWith('==') ? 2 : base64.endsWith('=') ? 1 : 0;
  return Math.max(0, Math.floor(base64.length / 4) * 3 - padding);
}

const BASE64_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

export function toBase64(bytes: Uint8Array): string {
  let result = '';
  for (let index = 0; index < bytes.length; index += 3) {
    const first = bytes[index] ?? 0;
    const second = bytes[index + 1];
    const third = bytes[index + 2];
    const chunk = (first << 16) | ((second ?? 0) << 8) | (third ?? 0);
    result += BASE64_ALPHABET.charAt((chunk >> 18) & 0x3f);
    result += BASE64_ALPHABET.charAt((chunk >> 12) & 0x3f);
    result += second === undefined ? '=' : BASE64_ALPHABET.charAt((chunk >> 6) & 0x3f);
    result += third === undefined ? '=' : BASE64_ALPHABET.charAt(chunk & 0x3f);
  }
  return result;
}
